import {
    NgbDateAdapter,
    NgbDateNativeAdapter,
    NgbDateParserFormatter,
} from '@cmps/ng-bootstrap';

import { DateParserFormatter } from './date-parser-formatter';
import { DateTimeI18nLocaleProvider } from './datetime-i18n-locale-provider';
import { DateTimeLocaleProvider } from './datetime-locale-provider';
import { DateTimeParserFormatter } from './datetime-parser-formatter';

/** intended for component level usage to avoid overwriting the global defaults */
export const DateProviders = [
    DateTimeParserFormatter,
    { provide: NgbDateAdapter, useClass: NgbDateNativeAdapter },
    { provide: NgbDateParserFormatter, useClass: DateParserFormatter },
    { provide: DateTimeLocaleProvider, useClass: DateTimeI18nLocaleProvider },
];
